'use client';
import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import type { RootState } from '@/lib/redux-toolkit/store';
export interface SettingState {
    value: any
}

const initialState: SettingState = {
    value:{
        breadcrumb: [{id:1, title:'Dashboard',url:'/'}],
        loading: false,
        page:{path:'/'}
    }
}

export const settingSlice = createSlice({
    name: 'setting',
    initialState,
    reducers: {
        setBreadcrumb:(state,action: PayloadAction<any>) => {
            state.value.breadcrumb = action.payload;
        },
        showLoading:(state) => {
            state.value.loading = true;
        },
        hideLoading:(state) => {
            state.value.loading = false;
        },
        setPagePath:(state,action: PayloadAction<string>) => {
          state.value.page.path = action.payload
        }
    },
})

export const {
    setBreadcrumb,
    showLoading,
    hideLoading,
    setPagePath} = settingSlice.actions
// @ts-ignore
export const getSetting = (state: RootState) => state.setting.value
export default settingSlice.reducer